
import React, { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import DataTable, { createTheme } from "react-data-table-component";
import { useTheme } from "../../../context/ThemeContext";
import TableLoader from "../../skeletons/TableLoader";
import { checkPermission } from "../../../helpers/GeneralHelper";
import { utcToLocal } from "../../../helpers/DateHelper";
import { useNavigate } from "react-router-dom"; // import useNavigate
import { getCmsDataTableStyles } from "../../../helpers/DataTableStyles";

export default function ClientTable({
  module,
  data,
  loading,
  totalRows,
  page,
  limit,
  fetchData,
  isTrash,
  openDeleteModal,
  handleView
}) {
  const navigate = useNavigate(); // Initialize useNavigate

  const columns = [
    {
      name: "#",
      selector: (row, index) => <div>{((page - 1) * limit) + index + 1}.</div>,
      width: '100px'
    },
    {
      name: "Client Name",
      selector: (row) => row.client_name,
      sortable: true, // ✅ enable sorting
    },
    {
      name: "Address",
      selector: (row) => row.client_address,
      sortable: true, // ✅ enable sorting
      wrap: true,
      style: {
        whiteSpace: 'normal',
        wordBreak: 'break-word',
      },
    },
    {
      name: "GSTIN",
      selector: (row) => row.client_gstin,
      sortable: true, // ✅ enable sorting
    },
    {
      name: "Branches",
      selector: (row) => Number(row.branch_count) || 0,
      sortable: true,
      width: "110px",
      cell: (row) => {
        const count = Number(row.branch_count) || 0;
        return (
          <span
            className={`badge ${count > 0 ? "bg-primary-transparent" : "bg-secondary-transparent"}`}
            title={`${count} billing branch${count === 1 ? "" : "es"}`}
          >
            {count}
          </span>
        );
      },
    },
    {
      name: "Create Date",
      selector: (row) => row.client_create_time ? utcToLocal(row.client_create_time) : 'N/A',
      sortable: true, // ✅ enable sorting
      style: {
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        maxWidth: 'none',
      },
      wrap: true,
    },
  ];

  // Check permissions for edit and delete
  if (!isTrash && (checkPermission(module.route, 'edit') || checkPermission(module.route, 'delete'))) {
    columns.push({
      name: "Action",
      right: "true",
      cell: row => (
        <div className="hstack gap-2 fs-15">
          {checkPermission(module.route, 'edit') && (
            <button
              type="button"
              className="btn btn-icon btn-sm btn-info"
              title="Edit"
              onClick={() => navigate(`/clients/${row.client_unique_id}/edit`)} // Navigate to the edit page
            >
              <i className='bx bxs-edit'></i>
            </button>
          )}
          {/* {console.log(row)} */}
          {checkPermission(module.route, 'delete') && <button type="button" className="btn btn-icon btn-sm btn-danger" title="Delete" onClick={() => openDeleteModal(row)}>
                      <i className='bx bxs-trash'></i>
                    </button>}
        </div>
      )
    });
  }

  if (isTrash) {
    columns.push({
      name: "Deleted At",
      selector: (row) => utcToLocal(row.client_delete_time)
    });
  }

  const { theme } = useTheme();

  const handlePageChange = async (page) => {
    fetchData(limit, page);
  };

  const handleLimitChange = async (newLimit, page) => {
    //if ((newLimit !== 10 && page !== 1) || localStorage.getItem(module.key)) {
      fetchData(newLimit, page);
    //}
  };

  useEffect(() => {
    fetchData(limit, page);
  }, [isTrash]);

  createTheme("dark", {
    text: {
      primary: "#a2a3a4",
      secondary: "#2aa198",
    },
    background: {
      default: "#252729",
    },
    context: {
      background: "#cb4b16",
      text: "#a2a3a4",
    },
    divider: {
      default: "#073642",
    },
    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.08)",
      disabled: "rgba(0,0,0,.12)",
    },
  });

  return (
    <DataTable
      className="clickable cms-data-table"
      //onRowClicked={(row) => handleView(row)}
      onRowClicked={(row) => navigate(`/clients/${row.client_unique_id}/view`)}
      columns={columns}
      data={data}
      pagination
      paginationServer
      paginationTotalRows={totalRows}
      onChangeRowsPerPage={handleLimitChange}
      onChangePage={handlePageChange}
      progressPending={loading}
      progressComponent={<TableLoader noOfColumn={columns.length} />}
      fixedHeader
      fixedHeaderScrollHeight="550px"
      highlightOnHover
      paginationPerPage={10}  // default page size
      paginationRowsPerPageOptions={[10, 25, 50, 100, totalRows]} // 👈 added custom options
      theme={`${theme === "light" ? "light" : "dark"}`}
      customStyles={getCmsDataTableStyles(theme)}
    />
  );
}
